import { Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BaseDialogActionData, ButtonColor, CommonActionKey, EnumHelper, FormHelper, LiquidityEvent, ResolutionStatus } from 'common';
import { Observable } from 'rxjs';

@Component({
    selector: 'ifb-account-liquidity-event-add',
    templateUrl: './account-liquidity-event-add.component.html',
    styleUrls: ['./account-liquidity-event-add.component.scss'],
    standalone: false
})
export class AccountLiquidityEventAddComponent {
  actions: BaseDialogActionData[] = [
    { actionKey: CommonActionKey.Cancel, label: 'Cancel', buttonColor: ButtonColor.Default },
    { actionKey: CommonActionKey.Ok, label: 'Ok', buttonColor: ButtonColor.Primary },
  ];
  
  resolutionStatusOptions = EnumHelper.getNamesAndValues(ResolutionStatus);
  liquidityForm: UntypedFormGroup;
  data: LiquidityEvent;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private dialogRef: MatDialogRef<AccountLiquidityEventAddComponent>
    ) {

    const today = new Date();
    today.setMilliseconds(0);
    today.setSeconds(0);
    today.setMinutes(0);
    today.setHours(0);
    this.liquidityForm = this.formBuilder.group({
      resolutionStatus: [undefined, Validators.required],
      resolutionDate: [today, Validators.required]
    });
   }

  static show(dialog: MatDialog, liquidityEvent: LiquidityEvent): Observable<any> {
    return dialog
      .open(AccountLiquidityEventAddComponent, {
        data: liquidityEvent,
        closeOnNavigation: true,
      })
      .afterClosed();
  }

  onActionClicked(actionData: BaseDialogActionData): void {
    if (actionData.actionKey === CommonActionKey.Ok) {
      this.confirm();
      return;
    }

    this.dialogRef.close();
  }

  private confirm(): void {
    if (!this.isFormDataValid()) {
      FormHelper.showInvalidFormFields(this.liquidityForm);
      return;
    }

    this.dialogRef.close({
      resolutionStatus: this.liquidityForm.controls.resolutionStatus.value, 
      resolutionDate: this.liquidityForm.controls.resolutionDate.value
    })
  }

  private isFormDataValid(): boolean {
    return this.liquidityForm.valid && this.liquidityForm.dirty;
  }
}